<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      persistent
  >
    <v-card>
      <v-card-title>
        {{ processType === 'new' ? 'Sepet Oluştur' : 'Sepet Düzenle' }}
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container-xxl-fluid">
          <div class="row">
            <div class="col-lg-4">
              <h4 class="text-center">Cari Verileri</h4>
              <div class="row" v-for="item in currentTypes" :key="item.id">
                <div class="col-lg-6">
                  <v-select
                      v-model="item.currentType"
                      label="Cari Tipi"
                      :items="[
                      {value: 1, text: 'Tüm Cariler'},
                      {value: 2, text: 'Cari Kodu'},
                      {value: 3, text: 'Grup Kodu'},
                      {value: 4, text: 'Kod1 Kodu'},
                      {value: 5, text: 'Kod2 Kodu'},
                      {value: 6, text: 'Kod3 Kodu'},
                      {value: 7, text: 'Kod4 Kodu'},
                      {value: 8, text: 'Kod5 Kodu'}
                  ]"
                      item-text="text"
                      item-value="value"
                      dense
                      filled
                      solo
                      placeholder=" "
                      clearable
                      hide-details
                      @change="e => currentTypeValueChange(currentTypes.indexOf(item),e)"
                  >

                  </v-select>
                </div>
                <div class="col-lg-6">
                  <search-select
                      :search-type="'current'"
                      @itemChange="(e) => (item.currentKey = e)"
                      :label="'Cari Veri'"
                      v-if="item.currentType === 2"

                  >
                  </search-select>
                  <v-select
                      v-model="item.currentKey"
                      label="Cari Tipi"
                      :items="item.currentCodesListResult"
                      item-value="code"
                      item-text="name"
                      dense
                      filled
                      solo
                      placeholder=" "
                      clearable
                      hide-details
                      v-if="item.currentType !== 1 && item.currentType !== 2 && item.currentType != null"
                  >
                  </v-select>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 text-end">
                  <v-btn
                      color="danger darken-2"
                      class="mx-1 text-light"
                      small
                      @click="currentTypes.pop()">Satır Çıkar
                  </v-btn>
                  <v-btn color="primary darken-2" small @click="appendCurrentTypeRow">Satır Ekle</v-btn>
                </div>

              </div>
            </div>
            <div class="col-lg-8">
              <div class="row">
                <div class="col-lg-12">
                  <v-file-input
                      label="Resim (Dosya Seçimi)"
                      dense
                      filled
                      solo
                      placeholder=" "
                      truncate-length="50"
                  ></v-file-input>
                </div>
                <div class="col-lg-12">
                  <v-text-field
                      :error-messages="
                              validationMessages($v.name, 'İsim')
                            "
                      v-model="name"
                      @input="$v.name.$touch()"
                      @blur="$v.name.$touch()"
                      label="Sepet İsmi"
                      dense
                      filled
                      solo
                      placeholder=" "
                      rows="4"
                  ></v-text-field>
                </div>
                <div class="col-lg-12">
                  <v-textarea
                      :error-messages="
                              validationMessages($v.definition, 'Tanım')
                            "
                      @input="$v.definition.$touch()"
                      @blur="$v.definition.$touch()"
                      v-model="definition"
                      label="Sepet Tanım"
                      dense
                      filled
                      solo
                      placeholder=" "
                      rows="4"
                  ></v-textarea>
                </div>
                <div class="col-lg-6">
                  <v-menu
                      transition="scale-transition"
                      offset-y
                      :close-on-content-click="false"
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          :error-messages="
                              validationMessages($v.startDate, 'Başlangıç Tarihi')
                            "
                          @input="$v.startDate.$touch()"
                          @blur="$v.startDate.$touch()"
                          :value="formattedDate(startDate)"
                          label="Tarih Aralık Başlangıç"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          dense
                          filled
                          solo
                          placeholder=" "
                          clearable
                          @click:clear="startDate = null"
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="startDate"
                        locale="tr"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="col-lg-6">
                  <v-menu
                      transition="scale-transition"
                      offset-y
                      :close-on-content-click="false"
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          :error-messages="
                              validationMessages($v.finishDate, 'Bitiş Tarihi')
                            "
                          @input="$v.finishDate.$touch()"
                          @blur="$v.finishDate.$touch()"
                          :value="formattedDate(finishDate)"
                          label="Tarih Aralık Bitiş"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          dense
                          filled
                          solo
                          placeholder=" "
                          clearable
                          @click:clear="finishDate = null"
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="finishDate"
                        locale="tr"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="col-lg-6">
                  <v-text-field
                      :error-messages="
                              validationMessages($v.stockTotalQuantity, 'Toplam Miktar')
                            "
                      @input="$v.stockTotalQuantity.$touch()"
                      @blur="$v.stockTotalQuantity.$touch()"
                      v-model="stockTotalQuantity"
                      label="Toplam Miktar"
                      dense
                      filled
                      solo
                      placeholder=" "
                  ></v-text-field>
                </div>
                <div class="col-lg-6">
                  <v-text-field
                      :error-messages="
                              validationMessages($v.freeTotalQuantity, 'Toplam Bedelsiz Miktar')
                            "
                      @input="$v.freeTotalQuantity.$touch()"
                      @blur="$v.freeTotalQuantity.$touch()"
                      v-model="freeTotalQuantity"
                      label="Toplam Bedelsiz Miktar"
                      dense
                      filled
                      solo
                      placeholder=" "
                  ></v-text-field>
                </div>
                <div class="col-lg-6">
                  <v-switch
                      :error-messages="
                              validationMessages($v.isActive, 'Durum')
                            "
                      @input="$v.isActive.$touch()"
                      @blur="$v.isActive.$touch()"
                      v-model="isActive"
                      class="mb-3"
                      label="Durum"
                      dense
                      filled
                      solo
                      placeholder=" "
                      inset
                      hide-details
                  >
                  </v-switch>
                </div>
                <div class="col-lg-6">
                  <v-select
                      v-model="salesPersonCode"
                      label="Plasiyer"
                      clearable
                      dense
                      filled
                      solo
                      placeholder=" "
                      :items="salesPersonList"
                      :item-text="item => item.name"
                      :item-value="item => item.code"
                  >
                  </v-select>
                </div>
                <div class="col-lg-6">
                  <v-select
                      v-model="categoryId"
                      label="Sepet Kategorisi"
                      clearable
                      dense
                      filled
                      solo
                      placeholder=" "
                      :items="basketCategoryList"
                      :item-text="item => item.name"
                      :item-value="item => item.id"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr>
              <v-tabs centered icons-and-text mobile-breakpoint="lg">
                <v-tab>
                  ÜRÜN KALEMLERİ
                  <v-icon> mdi-label-percent</v-icon>
                </v-tab>
                <v-tab>
                  BEDELSİZ ÜRÜN KALEMLERİ
                  <v-icon> mdi-basket</v-icon>
                </v-tab>
                <v-tab-item>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-6 text-center">
                        <strong>Ürün Kalem Seçimi</strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'stock'"
                            @itemChange="(e) => (selectedStock = e)"
                            :label="'Ürün Seçimi'"
                            :placeholder="'Ürün Arayın...'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="stockQuantity"
                            label="Miktar"
                            type="number"
                            min="1"
                            dense
                            filled
                            solo
                            placeholder=" "
                            :error-messages="
                              validationMessages($v.stockQuantity, 'Miktar')
                            "
                            @input="$v.stockQuantity.$touch()"
                            @blur="$v.stockQuantity.$touch()"
                        >

                        </v-text-field>
                      </div>
                      <div class="col-lg-1">
                        <v-btn color="primary darken-2" small @click="addStockToStockItemsList">Ürün Ekle</v-btn>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th>Stok Kodu</th>
                            <th>Stok Adı</th>
                            <th>Miktar</th>
                            <th class="text-center">İşlem</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item,i) in stockItemsList" :key="i">
                            <td>{{ item.stockCode }}</td>
                            <td>{{ item.stockName }}</td>
                            <td>{{ item.quantity }}</td>
                            <td class="text-center">
                              <b-button
                                  href="javascript:void(0);"
                                  class="action-icon text-light"
                                  size="sm"
                                  variant="danger"
                                  pill
                                  @click="removeStockFromStockItemsList(i)"
                              >
                                <i class="mdi mdi-trash-can font-size-14"></i>
                              </b-button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-6 text-center">
                        <strong>Bedelsiz Ürün Kalem Seçimi</strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'stock'"
                            @itemChange="(e) => (selectedStock2 = e)"
                            :label="'Ürün Seçimi'"
                            :placeholder="'Ürün Arayın...'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="stockQuantity2"
                            label="Miktar"
                            type="number"
                            min="1"
                            dense
                            filled
                            solo
                            placeholder=" "
                            :error-messages="
                              validationMessages($v.stockQuantity2, 'Miktar')
                            "
                            @input="$v.stockQuantity2.$touch()"
                            @blur="$v.stockQuantity2.$touch()"
                        >

                        </v-text-field>
                      </div>
                      <div class="col-lg-1">
                        <v-btn color="primary darken-2" small @click="addStockToFreeStockItemsList">Ürün Ekle</v-btn>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th>Stok Kodu</th>
                            <th>Stok Adı</th>
                            <th>Miktar</th>
                            <th class="text-center">İşlem</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item,i) in freeStockItemsList" :key="item.stockCode">
                            <td>{{ item.stockCode }}</td>
                            <td>{{ item.stockName }}</td>
                            <td>{{ item.quantity }}</td>
                            <td class="text-center">
                              <b-button
                                  href="javascript:void(0);"
                                  class="action-icon text-light"
                                  size="sm"
                                  variant="danger"
                                  pill
                                  @click="removeStockFromFreeStockItemsList(i)"
                              >
                                <i class="mdi mdi-trash-can font-size-14"></i>
                              </b-button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs>
            </div>

          </div>
        </div>
        <hr>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small class="me-1" color="secondary" @click="dialog = false">İptal Et</v-btn>
          <v-btn small color="success" @click="saveBasket">Sepeti Kaydet</v-btn>
        </div>

      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import {minLength, required} from "vuelidate/lib/validators";
import {validationMessages} from "@/validationMessages";
import {showProcessPromptMessage, showProcessSuccessMessage, showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";


export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    orderNumber: {
      type: String,
      default: null
    },
    processType: {
      type: String,
      default: "new",
    },
    basketId: {
      type: Number,
      default: null
    },
  },
  components: {SearchSelect},
  computed: {
    ...mapState("current", ["salesPersonList"]),
    ...mapState("basket", ["basketCategoryList"]),
    ...mapState("auth", ["user"]),

  },
  mounted() {
    this.fetchSalesPersonList({
      params: {},
      body: {}
    })
  },
  validations: {
    name: {
      required,
    },
    stockTotalQuantity: {
      required,
    },
    freeTotalQuantity: {
      required,
    },
    isActive: {
      required,
    },
    startDate: {
      required,
    },
    finishDate: {
      required,
    },
    definition: {
      required,
    },
    selectedStock: {
      required,
    },
    selectedStock2: {
      required,
    },
    stockQuantity: {
      required,
      minLength: minLength(1),
    },
    stockQuantity2: {
      required,
      minLength: minLength(1),
    },
  },
  data() {
    return {
      dialog: false,
      currentTypes: [],
      name: null,
      startDate: null,
      finishDate: null,
      salesPersonCode: null,
      categoryId: null,
      searchStock: null,
      searchStockTimeout: null,
      searchStockLoading: false,
      selectedStock: null,
      stockList: [],
      searchStock2: null,
      searchStockTimeout2: null,
      searchStockLoading2: false,
      selectedStock2: null,
      stockList2: [],
      stockQuantity: 1,
      stockQuantity2: 1,
      stockItemsList: [],
      freeStockItemsList: [],
      definition: null,
      stockTotalQuantity: null,
      freeTotalQuantity: null,
      isActive: true,
    }

  },
  methods: {
    ...mapActions("stock", ["fetchSingleStock"]),
    removeStockFromFreeStockItemsList(index) {
      showProcessPromptMessage({
        title: 'Ürün Listeden Çıkarılıyor',
        text: 'Devam etmek istediğinize emin misiniz ?'
      }).then(confirm => {
        if (confirm.isConfirmed) {
          this.freeStockItemsList.splice(index, 1);
        }
      })

    },
    async addStockToFreeStockItemsList() {
      this.$v.stockQuantity2.$touch()
      this.$v.selectedStock2.$touch();
      if (this.$v.selectedStock2.$invalid || this.$v.stockQuantity2.$invalid) {

        showProcessErrorMessage({
          title: 'Lütfen Gerekli Alanları Doldurun'
        })
      } else {
        let selectedStockName = await this.fetchSingleStock({
          params: {
            userId: this.user.UserId,
            stockCode: this.selectedStock2
          }
        });
        let pushObject = {
          stockCode: this.selectedStock2,
          stockName: selectedStockName.name,
          unit: 1,
          quantity: this.stockQuantity2,
          type: 2
        }
        this.freeStockItemsList.push(pushObject);
        showProcessSuccessMessage({
          title: 'Stok Ekleme Başarılı',
          text: `Eklenen Stok: ${pushObject.stockName}\n Miktar : ${pushObject.quantity}`
        })
      }

    },
    removeStockFromStockItemsList(index) {
      showProcessPromptMessage({
        title: 'Ürün Listeden Çıkarılıyor',
        text: 'Devam etmek istediğinize emin misiniz ?'
      }).then(confirm => {
        if (confirm.isConfirmed) {
          this.stockItemsList.splice(index, 1);
        }
      })

    },
    async addStockToStockItemsList() {
      this.$v.stockQuantity.$touch()
      this.$v.selectedStock.$touch();
      if (this.$v.selectedStock.$invalid || this.$v.stockQuantity.$invalid) {
        showProcessErrorMessage({
          title: 'Lütfen Gerekli Alanları Doldurun'
        })
      } else {
        let selectedStockName = await this.fetchSingleStock({
          params: {
            userId: this.user.UserId,
            stockCode: this.selectedStock
          }
        });
        let pushObject = {
          stockCode: this.selectedStock,
          stockName: selectedStockName.name,
          unit: 1,
          quantity: this.stockQuantity,
          type: 1
        }
        this.stockItemsList.push(pushObject);
        showProcessSuccessMessage({
          title: 'Stok Ekleme Başarılı',
          text: `Eklenen Stok: ${pushObject.stockName}\n Miktar : ${pushObject.quantity}`
        })
      }

    },
    validationMessages,
    formattedDate,
    ...mapActions("current", ["fetchSalesPersonList", "fetchCurrentCodesList", "fetchCurrentList"]),
    ...mapActions("basket", ["fetchBasketCategoryList", "basketAdd", "fetchBasketSingle", "basketUpdate"]),
    ...mapActions("stock", [
      "fetchStockList"
    ]),
    async _fetchCurrentList(index, searchText) {
      index
      this.currentTypes[index].currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(!(searchText === "" || searchText == null)) && {searchText: searchText}
        },
        body: {},
        loading: false
      });
      this.currentTypes.splice(index, 1, this.currentTypes[index])
      this.currentSearchLoading = false;
    },
    async _fetchCurrentCodesList(index, tableType) {
      this.currentTypes[index].currentCodesListResult = await this.fetchCurrentCodesList({
        params: {
          tableType: tableType
        },
        body: {},
        loading: false
      });
      this.currentTypes.splice(index, 1, this.currentTypes[index])

    },
    currentSearchText: function (index, searchText) {
      if (searchText) {
        this.currentTypes[index].currentSearchResult = [];
        if (this.currentTypes[index].searchCurrentTimeout)
          clearTimeout(this.currentTypes[index].searchCurrentTimeout);
        this.currentTypes[index].currentSearchLoading = true
        this.currentTypes[index].searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList(index, searchText);


        }, 2000);
      }
    },
    currentTypeValueChange(index, value) {
      this.currentTypes[index].currentCodesListResult = [];
      switch (value) {
        case 1:
          // this._fetchCurrentCodesList(index,value)
          break;
        case 2:
          //  this._fetchCurrentCodesList(index,value)
          break;
        case 3:
          this._fetchCurrentCodesList(index, value - 2)
          break;
        case 4:
          this._fetchCurrentCodesList(index, value - 2)
          break;
        case 5:
          this._fetchCurrentCodesList(index, value - 2)
          break;
        case 6:
          this._fetchCurrentCodesList(index, value - 2)
          break;
        case 7:
          this._fetchCurrentCodesList(index, value - 2)
          break;
        case 8:
          this._fetchCurrentCodesList(index, value - 2)
          break;
      }
    },
    appendCurrentTypeRow() {
      let idVal = this.currentTypes.length;
      this.currentTypes.push({
        id: idVal,
        currentSearchText: "",
        currentSearchLoading: false,
        currentSearchResult: [],
        searchCurrentTimeout: null,
        selectedCurrent: null,
        currentKey: null,
        currentCodesListResult: [],
        currentType: null
      });
    },
    async _fetchStockList() {
      this.stockList = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 30,
          userId: this.user.UserId,
        },
        body: {
          stock: this.searchStock,
          GenericCategories: null
        },
        onlyData: true,
        loading: false
      })
      this.searchStockLoading = false;
    },
    async _fetchStockList2() {
      this.stockList2 = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 30,
          userId: this.user.UserId,
        },
        body: {
          stock: this.searchStock2,
          GenericCategories: null
        },
        onlyData: true,
        loading: false
      })
      this.searchStockLoading2 = false;
    },
    async saveBasket() {
      if (this.processType === 'new') {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          await this._basketAdd();
        }
      } else {
        if (!this.$v.$invalid) {
          await this._basketUpdate()
        }
      }
    },
    async _basketUpdate() {
      let CurrentBaskets = [];

      this.currentTypes.map(item => CurrentBaskets.push({
        id: item.id,
        currentKey: item.currentKey,
        currentType: item.currentType
      }))
      let BasketDetails = [];
      this.freeStockItemsList.map(item => BasketDetails.push(item))
      this.stockItemsList.map(item => BasketDetails.push(item))

      await this.basketUpdate({
        params: {
          userId: this.user.UserId
        },
        body: {
          Basket: {
            id: this.basketId,
            name: this.name,
            definition: this.definition,
            startDate: this.startDate,
            finishDate: this.finishDate,
            stockTotalQuantity: this.stockTotalQuantity,
            freeTotalQuantity: this.freeTotalQuantity,
            salesPersonCode: this.salesPersonCode,
            isActive: this.isActive,
            categoryId: this.categoryId,
            image: null
          },
          BasketDetails,
          CurrentBaskets
        }
      });
      this.$parent._parentBasketList();
      this.dialog = false
    },
    async _basketAdd() {
      let CurrentBaskets = [];
      this.currentTypes.map(item => CurrentBaskets.push({currentKey: item.currentKey, currentType: item.currentType}))
      let BasketDetails = [];
      this.freeStockItemsList.map(item => BasketDetails.push(item))
      this.stockItemsList.map(item => BasketDetails.push(item))
      await this.basketAdd({
        params: {
          userId: this.user.UserId
        },
        body: {
          Basket: {
            definition: this.definition,
            name: this.name,
            startDate: this.startDate,
            finishDate: this.finishDate,
            stockTotalQuantity: this.stockTotalQuantity,
            freeTotalQuantity: this.freeTotalQuantity,
            salesPersonCode: this.salesPersonCode,
            isActive: this.isActive,
            categoryId: this.categoryId,
            //formData'ya çevirmek gerekebilir
            image: null
          },
          BasketDetails: BasketDetails,
          CurrentBaskets: CurrentBaskets
        }
      });
      this.$parent._fetchBasketList();
      this.dialog = false
    },
    async _fetchBasketSingle() {
      let basketSingleResult = await this.fetchBasketSingle({
        params: {
          basketId: this.basketId
        },
        body: {}
      });
      if (basketSingleResult) {
        this.definition = basketSingleResult.definition;
        this.name = basketSingleResult.name;
        this.startDate = basketSingleResult.startDate;
        this.finishDate = basketSingleResult.finishDate;
        this.stockTotalQuantity = basketSingleResult.stockTotalQuantity;
        this.freeTotalQuantity = basketSingleResult.freeTotalQuantity;
        this.salesPersonCode = basketSingleResult.salesPersonCode;
        this.isActive = basketSingleResult.isActive;
        this.categoryId = basketSingleResult.categoryId;
        this.image = basketSingleResult.image;
        this.freeStockItemsList = basketSingleResult.basketDetails.filter(item => item.type === 2);
        this.stockItemsList = basketSingleResult.basketDetails.filter(item => item.type === 1);
        this.currentTypes.splice(0, this.currentTypes.length);
        basketSingleResult.currentBaskets.map(item => this.currentTypes.push(item));
        for (let i = 0; i < this.currentTypes.length; i++) {
          if (this.currentTypes[i].currentType !== 1 && this.currentTypes[i].currentType !== 2 && this.currentTypes[i].currentType != null) {
            this.currentTypeValueChange(i, this.currentTypes[i].currentType);
          } else {

            this.currentSearchText(i, this.currentTypes[i].currentKey);
          }
        }

      } else {
        this.definition = null;
        this.name = null;
        this.startDate = null;
        this.finishDate = null;
        this.stockTotalQuantity = null;
        this.freeTotalQuantity = null;
        this.salesPersonCode = null;
        this.isActive = null;
        this.categoryId = null;
        this.image = null;
        this.freeStockItemsList = [];
        this.stockItemsList = [];
        this.currentTypes = [];
      }

    },
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
      if (newVal) {
        newVal;
      }

    },
    "showDialog": function (newVal) {
      this.$v.$reset();
      this.dialog = newVal
      if (newVal) {
        if (this.processType === 'new') {
          this.definition = null;
          this.name = null;
          this.startDate = null;
          this.finishDate = null;
          this.stockTotalQuantity = null;
          this.freeTotalQuantity = null;
          this.salesPersonCode = null;
          this.isActive = true;
          this.categoryId = null;
          this.image = null;
          this.freeStockItemsList = [];
          this.stockItemsList = [];
          this.currentTypes = [];
        } else if (this.processType === 'edit') {
          this._fetchBasketSingle()
        }
      }
    },
    searchStock(newVal) {
      this.stockList = [];
      if (newVal === "" || newVal === null) {
        if (this.searchStockTimeout)
          clearTimeout(this.searchStockTimeout);
      } else {
        this.searchStockLoading = true;
        if (this.searchStockTimeout)
          clearTimeout(this.searchStockTimeout);

        this.searchStockTimeout = setTimeout(() => {

          this._fetchStockList();
        }, 1000);
      }
    },

    searchStock2(newVal) {
      this.stockList2 = [];
      if (newVal === "" || newVal === null) {
        if (this.searchStockTimeout2)
          clearTimeout(this.searchStockTimeout2);
      } else {
        this.searchStockLoading2 = true;
        if (this.searchStockTimeout2)
          clearTimeout(this.searchStockTimeout2);

        this.searchStockTimeout2 = setTimeout(() => {

          this._fetchStockList2();
        }, 1000);
      }
    },

  }
}
</script>

